import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { cn } from "@/modern/utils";
import type { CheckGridOverviewItem } from "./types";
import { entityTypeLabel } from "./utils/hostEntity";
import type { CheckgridMenuAction } from "./CheckgridMenu";

type Props = {
  grid: CheckGridOverviewItem;
  /** Omit to render plain text (e.g. inside another button). */
  onAction?: (action: CheckgridMenuAction, grid: CheckGridOverviewItem) => void;
  className?: string;
};

export function CheckgridEntityLink({ grid, onAction, className }: Props) {
  if (!grid.entity_name) return null;
  const type = entityTypeLabel(grid);
  const label = (
    <>
      <span className="text-muted-foreground/70">{type}</span>
      <span aria-hidden> · </span>
      <span>{grid.entity_name}</span>
    </>
  );

  const trigger = onAction ? (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        onAction("openEntity", grid);
      }}
      className={cn(
        "block max-w-full truncate rounded-sm text-left hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className
      )}
    >
      {label}
    </button>
  ) : (
    <span className={cn("block truncate", className)}>{label}</span>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>{trigger}</TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-none whitespace-nowrap text-xs">
        {type} · {grid.entity_name}
      </TooltipContent>
    </Tooltip>
  );
}
